import type { LandingContent } from "../content/types";
import { Container } from "../components/Container";
import { assetPath } from "../i18n/routes";

type GallerySectionProps = {
  content: LandingContent["gallery"];
};

export function GallerySection({ content }: GallerySectionProps) {
  return (
    <section id="features" className="scroll-mt-20 bg-bg-primary py-20 lg:py-24">
      <Container>
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-display text-3xl font-bold text-text-primary sm:text-[38px]">{content.title}</h2>
          <p className="mt-4 text-base leading-relaxed text-text-secondary">{content.body}</p>
        </div>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {content.shots.map((shot) => (
            <figure key={shot.label} className="flex flex-col gap-3.5">
              {shot.image ? (
                <div className="overflow-hidden rounded-[22px] border border-subtle">
                  <img src={assetPath(shot.image)} alt={shot.label} className="block w-full" />
                </div>
              ) : (
                <div className="overflow-hidden rounded-[22px] border border-subtle bg-bg-card">
                  <div
                    className="flex h-[320px] items-center justify-center bg-gradient-to-br from-[#11192B] via-[#16213A] to-[#0E1626]"
                    role="img"
                    aria-label={shot.label}
                  >
                    <span className="rounded-full border border-subtle bg-black/20 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-text-muted">
                      {shot.label}
                    </span>
                  </div>
                </div>
              )}
            </figure>
          ))}
        </div>
      </Container>
    </section>
  );
}
